import React from 'react';
import { useMe } from '@/context/MeContext';
import CustomerDashboard from './CustomerDashboard';
import SystemDashboard from './SystemDashboard';

export default function Dashboard() {
  const { me } = useMe();
  const canViewSystemDashboard = me?.permissions.canViewSystemDashboard ?? false;

  if (canViewSystemDashboard) {
    return <SystemDashboard />;
  }

  return <CustomerDashboard />;
}
